
const actions = {
    setAccountDetail(vuexContext, payload) {
        vuexContext.commit('setAccountDetail', {
            email: payload[0].email,
            nick: payload[0].nick,
            avatar: payload[0].avatar,
            name: payload[0].name,
            surname: payload[0].surname,
        });
    }
};

export default actions;